import NetworkCall from "network/networkCall";
import Request from "network/request";

import { camelCaseKeysRecursively } from "utilities/generalUtility";

export default class CommissionPlan {
  static async getAll() {
    const res = await NetworkCall.fetch(Request.getAllCommission());
    return camelCaseKeysRecursively(res.data);
  }

  static async create(values) {
    const res = await NetworkCall.fetch(Request.createCommissionPlan(values));
    return res.data;
  }

  static async getCommissionPlans(planId) {
    const res = await NetworkCall.fetch(Request.getCommissionPlansById(planId));
    return camelCaseKeysRecursively(res.data);
  }

  static async addNewCommissionPlan(body) {
    const res = await NetworkCall.fetch(Request.addNewCommissionPlan(body));
    return res.data;
  }

  static async deleteUpcomingPlan(commissionId) {
    return NetworkCall.fetch(Request.deleteUpcommingPlan(commissionId));
  }

  static async getCommissionApproval(recruiterIds, loader = true) {
    const res = await NetworkCall.fetch(
      Request.getCommissionApprovals(recruiterIds),
      loader,
    );
    return camelCaseKeysRecursively(res.data);
  }

  static async editCommissionApproval(payload) {
    const res = await NetworkCall.fetch(
      Request.editCommissionApproval(payload),
    );
    return camelCaseKeysRecursively(res.data);
  }

  static async getCommissionStatements(recruiterIds) {
    const res = await NetworkCall.fetch(
      Request.getCommissionStatements(recruiterIds),
    );
    return camelCaseKeysRecursively(res.data);
  }

  static async createCommissionStatement(payload) {
    const res = await NetworkCall.fetch(
      Request.createCommissionStatement(payload),
    );
    return camelCaseKeysRecursively(res.data);
  }

  static async getCommissionStatementDetail(id) {
    const res = await NetworkCall.fetch(
      Request.getCommissionStatementDetails(id),
    );
    return camelCaseKeysRecursively(res.data);
  }

  static async deleteCommissionStatement(id) {
    const res = await NetworkCall.fetch(Request.deleteCommissionStatements(id));
    return camelCaseKeysRecursively(res.data);
  }

  static async editCommission(planId, params) {
    return NetworkCall.fetch(Request.v2.editCommission(planId, params));
  }

  static v2 = {
    editCurrentCommissionTimeline: async (
      commissionId,
      data,
      useLoading = true,
    ) => {
      return NetworkCall.fetch(
        Request.v2.editCurrentCommissionTimeline(commissionId, data),
        useLoading,
      );
    },
  };
}
